import "./Video.css"
import {Close} from "@mui/icons-material";


export default function Video() {

    return (
        <div className="video-container">
            <video
                className="video"
                src="/video.mp4"
                controls
                autoPlay
                muted
            />
            <button className="button" title="close" onClick={() =>
                document.querySelector(".video-container")!.remove()
            }><Close/></button>

        </div>
    )
}